import {
  ORDER_OPTIONS,
  QUANTITY_OPTIONS,
  REGISTRATION_QUANTITY_OPTIONS,
  type QuantityOption,
} from '@/shared/config';
import {
  DocumentType,
  SEARCH_TYPE_FIELD_OPTIONS,
  SearchTypeEnum,
  type EntityType,
  type OrderOptions,
} from '@/shared/lib';

const REVISION_COUNT_SORT = 'revision';

export const APPROVAL_DOCUMENT_SEARCH_URL = '/document-revisions/awaiting-approval/search';
export const APPROVAL_REGISTRATION_SEARCH_URL = '/matrices/awaiting-approval';

export interface ApprovalSearchField {
  id: string;
  name: string;
}

export interface ApprovalTabConfig {
  tabLabel: string;
  codeColumnLabel: string;
  /**
   * Cada aba tem a sua fonte: documento le revisao de documento, registro le a matriz enviada.
   * O endereco vive aqui, e nao no componente, para que a troca de aba troque a fonte.
   */
  searchUrl: string;
  searchFields: ApprovalSearchField[];
  quantityOptions: QuantityOption[];
  orderOptions: OrderOptions[];
  paginationEntity: EntityType;
  emptyTitle: string;
}

const REGISTRATION_SEARCH_FIELDS: ApprovalSearchField[] = SEARCH_TYPE_FIELD_OPTIONS.map((field) =>
  field.id === SearchTypeEnum.PREFIX ? { ...field, name: 'Registro' } : field
);

const REGISTRATION_ORDER_OPTIONS: OrderOptions[] = ORDER_OPTIONS.filter(
  (option) => option.sort !== REVISION_COUNT_SORT
);

export const APPROVAL_TAB_CONFIG: Record<DocumentType, ApprovalTabConfig> = {
  [DocumentType.DOCUMENT]: {
    tabLabel: 'Documentos',
    codeColumnLabel: 'Prefixo',
    searchUrl: APPROVAL_DOCUMENT_SEARCH_URL,
    searchFields: SEARCH_TYPE_FIELD_OPTIONS,
    quantityOptions: QUANTITY_OPTIONS,
    orderOptions: ORDER_OPTIONS,
    paginationEntity: 'documento',
    emptyTitle: 'Nenhum documento pendente no momento',
  },
  [DocumentType.REGISTRATION]: {
    tabLabel: 'Registros',
    codeColumnLabel: 'Registro',
    searchUrl: APPROVAL_REGISTRATION_SEARCH_URL,
    searchFields: REGISTRATION_SEARCH_FIELDS,
    quantityOptions: REGISTRATION_QUANTITY_OPTIONS,
    orderOptions: REGISTRATION_ORDER_OPTIONS,
    paginationEntity: 'registro',
    emptyTitle: 'Nenhum registro pendente no momento',
  },
};

export const getApprovalTabConfig = (documentType: DocumentType): ApprovalTabConfig =>
  Object.prototype.hasOwnProperty.call(APPROVAL_TAB_CONFIG, documentType)
    ? APPROVAL_TAB_CONFIG[documentType]
    : APPROVAL_TAB_CONFIG[DocumentType.DOCUMENT];
